import { Injectable } from '@angular/core';
import { AttributeValuesDto } from '../../../dtos/attributeValuesDto';
import * as _ from 'lodash';
import { CityVo } from '../../../vo/cityVo';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { group } from '@angular/animations';

@Injectable({
    providedIn: 'root'
})
export class FilterService {

    constructor(private globalDataService: GlobalDataService) {
    }


    getSearchFilters(attributeValues: AttributeValuesDto[]) {
        return _(attributeValues)
            .map((attribute) => {
                attribute.group = attribute.attribute.code;
                return attribute;
            })
            .groupBy('group')
            .map()
            .value();
    }

    cityByGroup(cities:any){
        return cities.map((city)=>{
            const groupedCity = new CityVo();
            groupedCity.name = this.globalDataService.getObjectTranslation(city.citiesTranslations, 'name');
            groupedCity.group = this.globalDataService.getObjectTranslation(city.citiesTranslations, 'admin_name');
            groupedCity.id = city.id;
            return groupedCity;
        })
    }

}
